import { DataRole } from '@mode-switch/express';
import { DomainResult } from '@mode-switch/query';
import { DataType } from '@mode-vegas/vegas';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { List } from 'immutable';
import { sortBy } from 'lodash';
import { formatInUTC } from '../time-format';

export class ReportFilterOptionsFactory {
  static QuarterNames = {
    1: 'Q1',
    2: 'Q2',
    3: 'Q3',
    4: 'Q4',
  };

  static MonthNames = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };

  static WeekdayNames = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  };

  static buildFlamingoDiscreteValueOptions(
    dataType: DataType,
    domain: DomainResult.Discrete<DataRole>
  ): List<FlamingoTypes.DiscreteValueOption> {
    switch (dataType) {
      case DataType.DATEQTR:
        return List<FlamingoTypes.DiscreteValueOption>().withMutations((options) => {
          for (const value of sortBy(domain.values)) {
            if (value === null) {
              options.push(new FlamingoTypes.DiscreteValueOption({ value, label: 'Null' }));
            } else {
              options.push(
                new FlamingoTypes.DiscreteValueOption({
                  value,
                  label: this.QuarterNames[value as keyof typeof this.QuarterNames],
                })
              );
            }
          }
        });
      case DataType.DATEMONTH:
        return List<FlamingoTypes.DiscreteValueOption>().withMutations((options) => {
          for (const value of sortBy(domain.values)) {
            if (value === null) {
              options.push(new FlamingoTypes.DiscreteValueOption({ value, label: 'Null' }));
            } else {
              options.push(
                new FlamingoTypes.DiscreteValueOption({
                  value,
                  label: this.MonthNames[value as keyof typeof this.MonthNames],
                })
              );
            }
          }
        });
      case DataType.DATEWKDAY:
        return List<FlamingoTypes.DiscreteValueOption>().withMutations((options) => {
          for (const value of sortBy(domain.values)) {
            if (value === null) {
              options.push(new FlamingoTypes.DiscreteValueOption({ value, label: 'Null' }));
            } else {
              options.push(
                new FlamingoTypes.DiscreteValueOption({
                  value,
                  label: this.WeekdayNames[value as keyof typeof this.WeekdayNames],
                })
              );
            }
          }
        });
      case DataType.DATETIME:
        return List<FlamingoTypes.DiscreteValueOption>().withMutations((options) => {
          for (const value of sortBy(domain.values)) {
            if (value === null) {
              options.push(new FlamingoTypes.DiscreteValueOption({ value, label: 'Null' }));
            } else {
              options.push(
                new FlamingoTypes.DiscreteValueOption({
                  value,
                  label: formatInUTC(new Date(value), 'yyyy-MM-dd HH:mm:ss'),
                })
              );
            }
          }
        });
      default:
        return List<FlamingoTypes.DiscreteValueOption>().withMutations((options) => {
          for (const value of sortBy(domain.values)) {
            if (value === null) {
              options.push(new FlamingoTypes.DiscreteValueOption({ value, label: 'Null' }));
            } else {
              options.push(new FlamingoTypes.DiscreteValueOption({ value, label: value }));
            }
          }
        });
    }
  }
}
